<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl"><icon name="location" class="w-6 h-6 -mt-1 mr-2 inline-block" />Listado de Localidades</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" :show-filter="true" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('locations.create')">
        <span>Crear</span>
        <span class="hidden md:inline">Localidad</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <th class="px-6 pt-6 pb-4">Url</th>
          <!-- <th class="px-6 pt-6 pb-4">Link</th> -->
          <th class="px-6 pt-6 pb-4">Ubicacion</th>
          <!-- <th class="px-6 pt-6 pb-4">Activado</th> -->
        </tr>
        <tr v-for="loc in locations.data" :key="loc.zona" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center text-blue-500" :href="route('locations.edit', loc.zona)">
               {{ loc.nombre }}
            </inertia-link>
          </td>
           <td class="border-t px-6">
            {{ loc.url }}
          </td>
           <td class="border-t px-6">
            {{ loc.ubicacion }}
          </td>
          
          <!--
           <td class="border-t">
              {{ ad.link }}
          </td>
           <td class="border-t">
              {{ ad.foto }}
          </td>
           <td class="border-t">
             {{ ad.publicado }}
          </td> -->
           
          <!-- 
          <td class="border-t">
             {{ category.description }}
          </td>
          <td class="border-t">
             {{ category.en_description }}
          </td> -->
        </tr>
        <tr v-if="locations.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron Localidades.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="locations.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'


export default {
  metaInfo: { title: 'Publicidad' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    locations: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('locations'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
